var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLinkedIn(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 8C0 3.58172 3.57587 0 7.98693 0H39.0131C43.4241 0 47 3.58172 47 8V40C47 44.4183 43.4241 48 39.0131 48H7.98693C3.57587 48 0 44.4183 0 40V8Z",
    fill: "#0077B5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.0838 41.2526H40.1611V26.9553C40.1611 19.8942 35.8936 17.4858 31.9445 17.4858C28.2928 17.4858 25.8122 19.9154 25.1273 21.3385V18.1356H18.321V41.2526H25.3983V28.7193C25.3983 25.3775 27.4569 23.7523 29.557 23.7523C31.5433 23.7523 33.0838 24.9012 33.0838 28.6265V41.2526Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.45041 10.7377C6.45041 13.1511 8.2772 14.9148 10.5306 14.9148C12.7844 14.9148 14.6112 13.1511 14.6112 10.7377C14.6112 8.32459 12.7844 6.5589 10.5306 6.5589C8.2772 6.5589 6.45041 8.32459 6.45041 10.7377Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.99211 41.2347H14.0691V18.1177H6.99211V41.2347Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedIn);
export default __webpack_public_path__ + "static/media/LinkedIn.0fc2bffe67f80f7a830253dc05cf4df6.svg";
export { ForwardRef as ReactComponent };